////////LIBRARY/////////
import React, { useState } from 'react'
import styled from 'styled-components'
import { isUndefined } from 'lodash'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import Header from '../Header'
import Menu from '../Navigations/Menu'
import TabsNavigations from '../TabsNavigation'
import Modals from '../Modals'
import Button from '../Ui/Buttons'
import ModalBody from '../Modals/ModalBody'
import { modalsActionCreators } from '../../store/actions'
import theme from '../../theme/theme'
import StringFormatter from '../../helpers/StringFormatter'
import Loading from '../Loading/Loading'
import ToastSuccess from '../ToastSuccess/ToastSuccess'
import TooltipHelpModal from '../TooltipHelp/components/TooltipHelpModal'
import TabsNavigationsRafters from '../TabsNavigationRafters/TabsNavigationRafters'
import { uriList } from '../../routings/settings/RouteList'
/////////ASSETS/////////
import Validation from '../../assets/icones/global/check.svg'

/////////STYLED/////////
const LayoutWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin: ${(props) =>
		props.isRedirect
			? props.isTabRafters
				? props.isTabRaftersDisplayed
					? '205px 14px 5px 64px'
					: '220px 14px 5px 64px'
				: '185px 14px 5px 64px'
			: '145px 14px 5px 64px'};
`
const TextModal = styled.div`
	margin: 0;
	padding: 15px 0;
`
const ButtonWrapper = styled.div`
	display: flex;
	height: 30px;
`
/////////STYLED/////////

/**
 * component use to format page wrapper position
 * margin for the header sticky and menu sticky
 * contain all global event modal and toast
 *
 * @param children
 * @param rest
 * @return {ReactDOM}
 */
const Layout = ({ _isRedirect, children, translations, usingAltPath, firstParent, ...rest }) => {
	const { modal } = useSelector(
		(state) => ({
			modal: state.modal,
			currentState: state,
		}),
		shallowEqual
	)

	const actionsModal = bindActionCreators(modalsActionCreators, useDispatch())
	const [backPage, setBackPage] = useState(false)
	const [isTabRafters, setIsTabRafters] = useState(false)
	const [isTabRaftersDisplayed, setIsTabRaftersDisplayed] = useState(false)

	const tabs = rest.routes

	if (!isUndefined(tabs.tabNameRafters) && !isTabRafters) setIsTabRafters(true)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<>
			<Loading />
			<TooltipHelpModal />
			<Modals
				showModal={modal.show} //modal.show
				closeModalHandler={!modal.path.length ? actionsModal.closeModal : actionsModal.closeModalRedirect}
				title={modal.title}
				level={modal.level}
				insideModalResponse={modal.insideModalResponse}
				icon={true}
			>
				<ModalBody>
					<TextModal>{StringFormatter.ResponseMessageParser(modal.key, modal.errorMsgParams) || modal.key}</TextModal>
					<ButtonWrapper>
						<Button
							actionHandler={!modal.path.length ? actionsModal.closeModal : actionsModal.closeModalRedirect}
							text={
								modal.path.length && modal.path !== uriList.login
									? translations['common__text__previous']
									: translations['common__text__ok']
							}
							bgColor={theme.colors.validation}
							img={Validation}
						/>
					</ButtonWrapper>
				</ModalBody>
			</Modals>
			<Header breadCrumb={rest.routes} firstParent={firstParent}></Header>

			<ToastSuccess message={'test'} />
			<Menu />
			<LayoutWrapper isRedirect={backPage} isTabRafters={isTabRafters} isTabRaftersDisplayed={isTabRaftersDisplayed}>
				{!isTabRafters ? (
					<TabsNavigations
						parentObj={rest.routes}
						translations={translations}
						setBackPage={setBackPage}
						usingAltPath={usingAltPath}
						firstParent={firstParent}
					>
						{' '}
						{/*setBackPage add to RouteList for set the top margin layout if goBack arrow*/}
						{children}
					</TabsNavigations>
				) : (
					<TabsNavigationsRafters
						parentObj={rest.routes} // Parent which contains route we are currently navigating
						translations={translations}
						setBackPage={setBackPage}
						firstParent={firstParent} // First level of breadcrumb
						usingAltPath={usingAltPath}
						statusPath={tabs.statusPath}
						displayingRafters={isTabRaftersDisplayed}
						setDisplayingRafters={setIsTabRaftersDisplayed}
					>
						{children}
					</TabsNavigationsRafters>
				)}
			</LayoutWrapper>
		</>
	)
}

Layout.propTypes = {}

export default Layout
